// extracted by mini-css-extract-plugin
module.exports = {"row":"InfiniteSpreadShowcase_row__iaXRl","more":"InfiniteSpreadShowcase_more__rNaQ8"};